import React, { ReactElement } from 'react';
import RawDataOverviewContainer from './OverviewContainer';
import { DeviceType, GraphLegendGroups, TimeSpan } from '../../constants/telosair-interfaces';
import Deque from '../../classes/deque';
import Graph from '../histogram/Graph';
import { Filters } from '../../services/localstorage.service';

type TrendsProps = {
  onZoom?: () => void;
  onBackPress?: () => void;
  isZoomed?: boolean;
  selectedParameters: string[];
  isDataLoading: boolean;
  lineChartGraphData: Record<string, Deque>;
  labels: Record<string, string>;
  timeSpan: TimeSpan;
  groupElements: GraphLegendGroups;
  groupStructure?: string;
  selectedGroupLegends: Record<string, string[]>;
  setSelectedGroupLegends: React.Dispatch<React.SetStateAction<Record<string, string[]>>>;
  type: DeviceType;
};

/**
 * React component for Trends.
 * @param props - Properties of Trends component.
 * @returns - React component for Trends.
 */
export default function Trends(props: TrendsProps): ReactElement {
  const {
    onZoom,
    onBackPress,
    setSelectedGroupLegends,
    isZoomed,
    isDataLoading,
    selectedParameters,
    lineChartGraphData,
    labels,
    timeSpan,
    groupElements,
    groupStructure,
    selectedGroupLegends,
    type
  } = props;
  return (
    <RawDataOverviewContainer
      size={isZoomed ? 'full' : '1/2'}
      onBackPress={onBackPress}
      onZoom={onZoom}
      sectionName="Trends"
      zoomed={isZoomed}
      loading={isDataLoading}
      noDataText={
        (selectedParameters.length === 0 && 'Please select a parameter') ||
        (Object.keys(lineChartGraphData).length === 0 && 'Data unavailable')
      }
    >
      <Graph<string>
        isZoomed={isZoomed}
        timeSpan={timeSpan}
        useDynamicLineColorPlugin={false}
        useTextPointPlugin={false}
        groupElements={groupElements}
        lineChartGraphData={lineChartGraphData}
        labels={labels}
        groupStructure={groupStructure}
        storageKey={Filters.dataTrendsKeys}
        selectedGroupLegends={selectedGroupLegends}
        setSelectedGroupLegends={setSelectedGroupLegends}
        type={type}
      />
    </RawDataOverviewContainer>
  );
}
